const nonAiActionTypes = [
  'QUESTION',
  'COMMAND',
];

const nonAiCheckTypes = [
  'QUESTION',
  'COMMAND_COUNT',
  'UNSOLICITED_DIALOGUE',
];

const nonAiEffectTypes = [
  'QUESTION',
  'COMMAND',
  'ANSWER',
  'UNSOLICITED_DIALOGUE'
];

const aiActionTypes = [
  'AI_QUESTION',
];

const aiCheckTypes = [
  'AI_QUESTION',
];

const aiEffectTypes = [
  'AI_UNSOLICITED_DIALOGUE',
  'AI_UPDATE_PROMPT',
  'AI_ANSWER'
];

module.exports = {
  nonAiActionTypes,
  nonAiCheckTypes,
  nonAiEffectTypes,
  aiActionTypes,
  aiCheckTypes,
  aiEffectTypes
};